import { CookiesDetails } from "@nju/feature-portal-documents";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function CookiesPage() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent spacing="l">
        <CookiesDetails />
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
